<template>
  <div class="editCommission">
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="提成名称" prop='feeName'>
              <el-input v-model="form.feeName" style="width:180px" placeholder="请输入提成名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="岗位" prop='postId'>
            <el-select v-model="form.postId" placeholder="请选择岗位" style="width:180px">
                <el-option :label="i.name" :value="i.id" v-for="(i,index) in postIdData" :key="'postId_'+index"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="提成类型" prop='isTeam'>
            <el-select v-model="form.isTeam" placeholder="请选择提成类型" style="width:180px">
                <el-option label="个人提成" value="0"></el-option>
                <el-option label="团队提成" value="1"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="生效时间" prop="startDate">
            <el-date-picker v-model="form.startDate" type="date" placeholder="选择生效时间" style="width:180px;" value-format="timestamp" :picker-options="pickerOptions1"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="提成来源" prop='commissionFrom'>
            <el-checkbox-group v-model="form.commissionFrom" class="checkBoxcom">
                <el-checkbox :label="1">零售销售</el-checkbox>
                <el-checkbox :label="2">服务销售</el-checkbox>
                <el-checkbox :label="3" v-if='$store.state.userInfo.brandId == 1'>服务消耗</el-checkbox>
                <el-checkbox :label="4" v-else>充值</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="addCommission">
        <el-col :span='1'><div style="height:32px"></div></el-col>
        <el-col :span="12">
          <el-form-item label="月度业绩范围（¥）" label-width="200px"></el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="提成（%）"></el-form-item>
        </el-col>
      </el-row>
      <el-row class="commissionList" v-for="(i,index) in form.detailList" :key="index">
        <el-col :span="5" style="text-align:right;padding-right:30px" v-if="index === 0">0</el-col>
        <el-col :span="5" v-else>
          <el-form-item :prop="'detailList.'+index+'.bottom'" :rules="rules.detailList.bottom" label-width="0">
            <el-input v-model="i.bottom" style="width:90px" readonly></el-input>
          </el-form-item>
        </el-col>
        <template v-if="index !== form.detailList.length -1">
          <el-col :span="2">
            <span>—</span>
          </el-col>
          <el-col :span="6">
            <el-form-item :prop="'detailList.'+index+'.top'" :rules="rules.detailList.top" label-width="0">
              <el-input v-model="i.top" style="width:90px" @input="bottomSet(i.top,index)"></el-input>
            </el-form-item>
          </el-col>
        </template>
        <template v-else>
          <el-col :span="8" class="grey">
            <span>以上</span>
          </el-col>
        </template>
        <el-col :span="11">
          <el-form-item :prop="'detailList.'+index+'.feeFactor'" :rules="rules.detailList.feeFactor" label-width="0" class="txtLeft">
            <el-input v-model="i.feeFactor" style="width:130px"></el-input>
            <el-button size="mini" class="delete" @click="deleteRow(index)" v-if="index !== form.detailList.length - 1 && index !== 0">删除</el-button>
            <el-button size="mini" class="addRow" @click="addRow()" v-if="index === form.detailList.length -2">添加</el-button>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="btnOptions">
        <el-button class="darkBtn" @click="resetData">取消</el-button>
        <el-button class="redBtn" @click="onSubmit" :disabled="btnOpenFlag">确定</el-button>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import infolist from '@/assets/js/info'
import { insertStoreFee, updateStoreFee } from "@/api";
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}

export default {
  props: ['cueRowData','openFlag','dialogRoyaltyVisible'],
  data() {
    // 价格
    const isvalidateMoney = (rule, value, callback) => {
      if (Number(value)) {
        if (
          !Number.isInteger(Number(value)) &&
          value.toString().split(".")[1].length > 2
        ) {
          callback(new Error("不能超过两位小数"));
        } else if (Number(value) > 9999999.99) {
          callback(new Error("金额最大9999999.99"));
        } else if (Number(value) < 0) {
          callback(new Error("金额不能为负"));
        } else if(rule.field.split('.')[2] == 'top' && value <= Number(this.form.detailList[rule.field.split('.')[1]].bottom)){
          callback(new Error('必须大于上个金额'));
        } else if(rule.field.split('.')[2] == 'bottom' && value < Number(this.form.detailList[rule.field.split('.')[1] - 1].top)){
          callback(new Error("必须不小于上个金额"));
        } else {
          callback();
        }
      } else if (!value || value == "") {
        callback();
      } else {
        callback(new Error("必须是数字或小数"));
      }
    };
    const isvalidateNoMoney = (rule, value, callback) => {
      if (Number(value)) {
        if (
          !Number.isInteger(Number(value)) &&
          value.toString().split(".")[1].length > 2
        ) {
          callback(new Error("不能超过两位小数"));
        } else if (Number(value) > 9999999.99) {
          callback(new Error("金额最大9999999.99"));
        } else if (Number(value) < 0) {
          callback(new Error("金额不能为负"));
        } else {
          callback();
        }
      } else if (value == 0 || !value || value == "") {
        callback();
      } else {
        callback(new Error("必须是数字或小数"));
      }
    };
    return {
      infolist:infolist,
      form: {
        feeName:'',
        postId:'',
        isTeam:'',
        startDate: "",
        commissionFrom:[],
        detailList:[
          {
            bottom:'0',
            top:'',
            feeFactor:''
          },
          {
            bottom:'',
            top:'',
            feeFactor:''
          }
        ]
      },
      pickerOptions1:{
        disabledDate(time) {
          return time.getTime() < (Date.now() - 3600 * 1000 * 24);
        },
      },
      rules: {
        feeName:[
            {required: true,message:'请输入提成名称',trigger: "blur"},
            { min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur"}
        ],
        postId:[
            { required: true, message: "请选择岗位", trigger: "change" }
        ],
        isTeam:[
            { required: true, message: "请选择提成类型", trigger: "change" }
        ],
        startDate: [
          {
            required: true,
            message: "请选择生效时间",
            trigger: "change"
          }
        ],
        commissionFrom:[
            { type: 'array', required: true, message: '请至少选择一个提成来源', trigger: 'change' }
        ],
        detailList:{
          bottom:[
            {
              required: true,
              message: '请输入月度业绩范围',
              trigger: "blur"
            },
            { type: "number", validator: isvalidateMoney, trigger: "blur" }
          ],
          top:[
            {
              required: true,
              message: '请输入月度业绩范围',
              trigger: "blur"
            },
            { type: "number", validator: isvalidateMoney, trigger: "blur" }
          ],
          feeFactor:[
            {
              required: true,
              message: "请输入提成",
              trigger: "blur"
            },
            { type: "number", validator: isvalidateNoMoney }
          ]
        }
      },
      btnOpenFlag:this.openFlag
    };
  },
  created () {    
    if(!this.cueRowData){
      this.form = this.$options.data().form;
    }else{
      this.form = Object.assign({},this.cueRowData);
      this.form.startDate = this.cueRowData.startDate ? new Date(this.cueRowData.startDate).getTime():'';
      this.form.commissionFrom = this.sourceType(this.cueRowData.sourceList);
      this.form.postId = Number(this.form.postId)
    }
    this.$nextTick(()=>{
      this.$refs.form.clearValidate();
    })
  },
  watch: {
    'dialogRoyaltyVisible'(val){
      if(!this.cueRowData){
        this.form = this.$options.data().form;
      }else{
        this.form = Object.assign({},this.cueRowData);
        this.form.startDate = this.cueRowData.startDate ? new Date(this.cueRowData.startDate).getTime():'';
        this.form.commissionFrom = this.sourceType(this.cueRowData.sourceList);
        this.form.postId = Number(this.form.postId)
      }
      this.$nextTick(()=>{
        this.$refs.form.clearValidate();
      })
    },
    'openFlag'(){
      this.btnOpenFlag = this.openFlag;
    }
  },
  computed: {
    postIdData(){
      let data = this.$store.state.userInfo.brandId == 1 ? this.infolist.postIdData1:(this.$store.state.userInfo.brandId == 2 ? this.infolist.postIdData2:(this.$store.state.userInfo.brandId == 3 ? this.infolist.postIdData3:this.infolist.postIdData));
      return data;
    },
    sourceType(){
      return function(val){
        let data = [];
        if(val){
          for(let i of val){
            if(i.sourceId && data.indexOf(i.sourceId) == -1){
              data.push(i.sourceId);
            }
          }
        }
        return data;
      }
    },
    socuceForm(){
      return function(val){
        let data = [];
        for(let i of val){
          data.push({
            sourceId:i
          })
        }
        return data;
      }
    }
  },
  methods: {
    bottomSet(top,index){
      if(top){
        this.form.detailList[index+1].bottom = top;
        this.$refs.form.clearValidate()
      }
    },
    deleteRow(index) {
      //   删除
      this.form.detailList.splice(index,1);
      this.form.detailList[index].bottom = this.form.detailList[index-1].top;
      this.$refs.form.clearValidate()
    },
    addRow() {
      //   添加
      let cueLen = this.form.detailList.length-1;
        this.form.detailList.splice(cueLen,0,{
            bottom:this.form.detailList[cueLen-1].top,
            top:'',
            feeFactor:''
        });

      this.$refs.form.clearValidate();
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        if (valid) {
            this.btnOpenFlag = true;
            this.form.feeType = '1';//1销售 服务消耗提成 2手工费提成	
            this.form.sourceList = this.socuceForm(this.form.commissionFrom)//1实体商品零售  2服务商品零售   3服务消耗提成  4充值提成  5手工费
            this.form.detailList[this.form.detailList.length - 1].top = 10000000
            if(!this.cueRowData){
                insertStoreFee(this.form).then(res=>{
                if (res.code == 1) {
                    // 关闭当前进入列表页
                    this.$emit("closeDialog", false);
                }else{
                    this.btnOpenFlag = false;
                }
                this.$message({
                    type: res.code == 1 ? "success" : "error",
                    message: res.msg
                });
                })
          }else{
            this.form.id = this.cueRowData.id;//修改的id
            updateStoreFee(this.form).then(res => {
              if (res.code == 1) {
                // 关闭当前进入列表页
                this.$emit("closeDialog", false);
              }else{
                this.btnOpenFlag = false;
              }
              this.$message({
                type: res.code == 1 ? "success" : "error",
                message: res.msg
              });
            });
          }
        } else {
          this.btnOpenFlag = false;
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetData() {
      this.$confirm(
        "确定要取消本次编辑的信息吗？取消后本次编辑的内容不保存",
        "提示",
        {
          distinguishCancelAndClose: true,
          confirmButtonText: "继续编辑",
          cancelButtonText: "确定取消",
          type: "warning"
        }
      )
        .then(() => {})
        .catch(action => {
          if (action === "cancel") {
            this.$message({
              type: "info",
              message: "已取消"
            });
            this.$refs.form.resetFields();
            this.$emit("closeDialog", false);
          }
        });
    }
  }
};
</script>
<style lang="less" scoped>
.editCommission {
  width: 100%;
  overflow: hidden;
  text-align: center;  
  .commissionList {
    margin: 20px 0;
    span {
      color: #c0c5cf;
      margin: 0 12px;
    }
    .grey {
      text-align: left;
      line-height: 26px;
      span {
        color: #666;
      }
    }
    .delete {
      color: #f83b56;
      font-weight: bold;
      border: 1px solid #f83b56;
    }
    .addRow {
      color: #42acef;
      font-weight: bold;
      border: 1px solid #42acef;
    }
  }
}
</style>
<style lang="less">
.editCommission {
  .lineH {
    .el-form-item__content {
      line-height: 25px;
      padding-top: 8px;
    }
  }
  .el-form-item__content {
    text-align: left;
  }
  .addCommission{
    .el-form-item__label{text-align: left}    
    .el-form-item{margin-bottom:0}
  }
  .commissionList {
    .el-form-item{margin-bottom:0}
    .el-form-item__content,.el-input{height: 30px;}
    .txtLeft{
      .el-form-item__content{
        text-align: left;
      }
    }
    .el-form-item__content{
      text-align: center;
      .el-input__inner,.el-button--mini{vertical-align:top}
    }
    .el-input__inner {
      height: 28px;
      line-height: 28px;
    }
  }
  .el-input__inner {
    height: 35px;
    line-height: 35px;
  }
  .btnOptions {
    margin-top: 50px;
    margin:0 0 20px 0;
    text-align: center;
    .el-button {
      width: 105px;
      height: 38px;
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/basicDataCenter/editCommission.vue